if (!customElements.get('hotspot-products')) {
  customElements.define(
    'hotspot-products',
    class HotspotProducts extends window.BAO.CustomElement {
      constructor () {
        super()

        this.initialiseHotspots()
      }

      initialiseHotspots () {
        this.els.trigger.elements.forEach(triggerEl => {
          this.handleClick = this.handleClick.bind(this)

          triggerEl.addEventListener('click', this.handleClick)
        })

        this.els.close.elements.forEach(closeEl => {
          this.handleClose = this.handleClose.bind(this)

          closeEl.addEventListener('click', this.handleClose)
        })
      }

      handleClick (event) {
        const clickedElement = event.target.closest(
          '[data-hotspot-products-el="trigger"]'
        )
        const currentState =
          clickedElement.getAttribute('aria-pressed') === 'true'

        this.els.trigger.elements.forEach(triggerEl => {
          triggerEl.setAttribute(
            'aria-pressed',
            triggerEl === clickedElement ? !currentState : false
          )
        })

        this.els.card.elements.forEach(cardEl => {
          cardEl.setAttribute(
            'aria-hidden',
            cardEl.dataset.hotspot === clickedElement.dataset.hotspot
              ? currentState
              : true
          )
        })
      }

      handleClose (event) {
        this.els.trigger.elements.forEach(triggerEl => {
          triggerEl.setAttribute('aria-pressed', false)
        })

        this.els.card.elements.forEach(cardEl => {
          cardEl.setAttribute('aria-hidden', true)
        })
      }
    }
  )
}
